import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'; // ✅ Import Vuex store

Vue.config.productionTip = false

new Vue({
  vuetify,
  store, // ✅ Inject Vuex store into the app
  router,
  render: h => h(App)
}).$mount('#app')
